import { render, staticRenderFns } from "./AnnotationDetailsContainer.vue?vue&type=template&id=c65fb9d0&scoped=true&"
import script from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./AnnotationDetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationDetailsContainer.vue?vue&type=style&index=0&id=c65fb9d0&prod&scoped=true&lang=css&"
import style1 from "./AnnotationDetailsContainer.vue?vue&type=style&index=1&id=c65fb9d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65fb9d0",
  null
  
)

export default component.exports